import { FormToFilling } from "../Filling/Types";

export type returnType = {
  success: boolean;
  item: string | null;
  subItem: string | null;
  chamado?: boolean;
  texto?: string | null;
  ocorrencia?: string | null;
  itemId?: string | null;
  subItemId?: number | null;
};

export default function CheckFilling(checklist: FormToFilling): returnType {
  const regexEmail = /^(?![.-])([A-Za-z0-9._%+-]+(?:(?<=.)[A-Za-z0-9._%+-]))@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  for (const item of checklist.itens) {
    for (const subItem of item.subitens) {
      const basicData = {
        success: false,
        item: item.nome as string,
        subItem: subItem.nome as string,
        itemId: item.id,
        subItemId: subItem.id,
      };
      const semPreenchimento = {
        ...basicData,
        texto: "sem preenchimento",
      };
      const semImagem = {
        ...basicData,
        texto: "é obrigarório ao menos uma imagem",
      };
      const semComentario = {
        ...basicData,
        texto: "é obrigarório adicionar um comentário",
      };
      if (subItem.obrigatoriedade?.preenchimento) {
        switch (subItem.tipo) {
          case "avaliacao":
            if (typeof subItem.nota !== "number") {
              return semPreenchimento;
            }
            let status: "conf" | "Nconf" | "NA" | "" = "";
            if ((subItem?.nota || subItem?.nota === 0) && (subItem.threshold || subItem.threshold === 0)) {
              if (subItem.nota === -1) status = "NA";
              else if (subItem.nota <= subItem.threshold) status = "Nconf";
              else status = "conf";
            }
            switch (status) {
              case "NA":
                if (subItem.obrigatoriedade?.NA?.img && !subItem?.img?.length) return semImagem;
                if (subItem.obrigatoriedade?.NA?.ocorrencia && !subItem?.ocorrencia?.length) return semComentario;
                break;
              case "Nconf":
                if (subItem.obrigatoriedade?.naoConforme?.img && !subItem.img?.length) return semImagem;
                if (subItem.obrigatoriedade?.naoConforme?.ocorrencia && !subItem.ocorrencia?.length) return semComentario;
                break;
              case "conf":
                if (subItem.obrigatoriedade?.conforme?.img && !subItem.img?.length) return semImagem;
                if (subItem.obrigatoriedade?.conforme?.ocorrencia && !subItem.ocorrencia?.length) return semComentario;
                break;
              default:
                break;
            }
            break;
          case "unique":
          case "multiple":
          case "list":
            if (!subItem.selecionados) {
              return semPreenchimento;
            }
            if (subItem?.selecionados) {
              if (subItem.obrigatoriedade.img) {
                if (!subItem.img?.length) {
                  return semImagem;
                }
              }
              if (subItem.obrigatoriedade.ocorrencia) {
                if (!subItem.obs?.length && subItem.tipo !== "multiple") {
                  return semComentario;
                }
                if (!subItem.ocorrencia?.length && subItem.tipo === "multiple") {
                  return semComentario;
                }
              }
            }
            break;
          case "assinatura":
            if (!subItem.assinatura) {
              return semPreenchimento;
            }
            if (subItem?.assinatura) {
              if (subItem.obrigatoriedade.img) {
                if (!subItem.img?.length) {
                  return semImagem;
                }
              }
              if (subItem.obrigatoriedade.ocorrencia) {
                if (!subItem.obs?.length) {
                  return semComentario;
                }
              }
            }
            break;
          case "cep":
          case "cpfcnpj":
          case "email":
          case "numero":
          case "placa":
          case "rg":
          case "telefone":
          case "data":
          case "hora":
          case "textoCurto":
          case "textoLongo":
            if (!subItem.ocorrencia) {
              return semPreenchimento;
            }
            switch (subItem.tipo) {
              case "cep":
                if (subItem.ocorrencia.length < 9) {
                  return {
                    ...basicData,
                    texto: "Cep precisa ter ao menos 8 caracteres",
                  };
                }
                break;
              case "cpfcnpj":
                if (![14, 18].includes(subItem.ocorrencia?.length)) {
                  return {
                    ...basicData,
                    texto: "CPF precisa ter minimo de 11 caracteres. CNPJ precisa ter minimo de 14 caracteres",
                  };
                }
                break;
              case "email":
                if (!regexEmail.test(subItem.ocorrencia)) {
                  return {
                    ...basicData,
                    texto: "e-mail inválido",
                  };
                }
                break;
              case "numero":
                if (subItem.ocorrencia < Number(subItem.minNumberVal)) {
                  return {
                    ...basicData,
                    texto: "Valor menor que o minímo definido",
                  };
                }
                if (subItem.ocorrencia > Number(subItem.maxNumberVal)) {
                  return {
                    ...basicData,
                    texto: "Valor maior que o minímo definido",
                  };
                }
                break;
              case "placa":
                if (subItem.ocorrencia?.length < 8) {
                  return {
                    ...basicData,
                    texto: "Placa deve ter 7 caracteres",
                  };
                }
                break;
              case "rg":
                if (subItem.ocorrencia.length !== 12) {
                  return {
                    ...basicData,
                    texto: "RG deve ter 9 caracteres",
                  };
                }
                break;
              case "telefone":
                if (![12, 13].includes(subItem.ocorrencia?.length)) {
                  return {
                    ...basicData,
                    texto: "Telefone deve ter no minímo 10 caracteres",
                  };
                }
                break;
            }
            if (subItem?.ocorrencia) {
              if (subItem.obrigatoriedade.img) {
                if (!subItem.img?.length) {
                  return semImagem;
                }
              }
              if (subItem.obrigatoriedade.ocorrencia) {
                if (!subItem.obs?.length) {
                  return semComentario;
                }
              }
            }
            break;
        }
      }
    }
  }
  return {
    success: true,
    item: "",
    subItem: "",
    itemId: "",
  };
}
